import InsufficientStock from '../insufficient-stock';
import OutOfStock from '../out-of-stock';

interface Props {
  isOnStock?: boolean;
  count?: number;
  fluentAvailableQuantity?: number;
  isPerpetualStock?: boolean;
}

const StockMessage = ({ isOnStock, count, fluentAvailableQuantity, isPerpetualStock = false }: Props) => {
  if (!isPerpetualStock && !isOnStock) {
    return <OutOfStock />;
  }
  if (!isPerpetualStock && fluentAvailableQuantity && count && fluentAvailableQuantity < count) {
    return <InsufficientStock />;
  }

  return <></>;
};

export default StockMessage;
